import React, { useState } from 'react';
import styles from './ExamScreen.module.css'; // используем твой .examMain
import { useAppConfig } from '../../context/AppConfigContext';

export default function ExamResult({ result, onComplete }) {
  const [currentPage, setCurrentPage] = useState(0);
  const results = result.result || [];
  const totalPages = results.length;
  const { t } = useAppConfig();
  const goToPage = (index) => {
    if (index >= 0 && index < totalPages) {
      setCurrentPage(index);
    }
  };

  const currentItem = results[currentPage];
  const feedback = currentItem.result;

  return (
    <div className={`${styles.examMain} ${styles.examResult}`}>
      <h2>{t.examBlock.resultTitle}</h2>
      <p><strong>{t.examBlock.totalScore}:</strong> {result.score}/100</p>

      <div className={styles.resultItem}>
        <p style={{ color: '#1E3A8A' }}>
          <strong>{t.examBlock.question}:</strong> {currentItem.question}
        </p>
        <p style={{ color: '#0089FF' }}>
          <strong>{t.examBlock.yourAnswer}:</strong> {currentItem.answer}
        </p>

        {feedback && (
          <>
            <p><strong>{t.examBlock.correctPoints}:</strong> {feedback.correct_point}</p>
            <p><strong>{t.examBlock.matchPoints}:</strong> {feedback.correspond_point}</p>

            {feedback.errors?.length > 0 && (
              <div>
                <strong>{t.examBlock.errors}:</strong>
                <ul>
                  {feedback.errors.map((err, i) => (
                    <li key={i}>{err}</li>
                  ))}
                </ul>
              </div>
            )}

            {feedback.advice && (
              <p><strong>{t.examBlock.advice}:</strong> {feedback.advice}</p>
            )}
          </>
        )}
      </div>

      {/* Пагинация с точками */}
	<div className={styles.pagination}>
	  {results.map((_, index) => (
		<span
		  key={index}
		  onClick={() => goToPage(index)}
		  className={`${styles.dot} ${index === currentPage ? styles.dotActive : ''}`}
		/>
	  ))}
	</div>

      {/* Кнопки перелистывания */}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <button
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 0}
          className={styles.nextButton}
        >
          ← {t.examBlock.prev}
        </button>
        {currentPage === totalPages - 1 ? (
          <button onClick={() => onComplete(onComplete)} className={styles.nextButton}>
            {t.examBlock.finishExam}
          </button>
        ) : (
          <button
            onClick={() => goToPage(currentPage + 1)}
            className={styles.nextButton}
          >
            {t.examBlock.next} →
          </button>
        )}
      </div>
    </div>
  );
}
